var _desc, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "18px",
    viewBox: "0 0 10 18",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6789 17.4178L2.6789 9.62743L0 9.62743L0 6.53169L2.6789 6.53169L2.6789 4.09251C2.6789 1.44241 4.34143 0 6.76886 0C7.93193 0 8.93085 0.085048 9.22074 0.122469L9.22074 2.89163L7.53726 2.89163C6.21702 2.89163 5.96205 3.50398 5.96205 4.39868L5.96205 6.53169L8.94133 6.53169L8.53268 9.62743L5.96205 9.62743L5.96205 17.4178",
    id: "Shape",
    fill: "#22252B",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.662b7ee5b210dba6a1047d357d89c8e4.svg";
export { ForwardRef as ReactComponent };